import React from 'react'
import cube from '../Assets/connect cube.png'
import Lottie from 'lottie-react';
import staticBg from '../Assets/static.json'
import { useNavigate } from 'react-router-dom';

const Connect = () => {

    const Navigate = useNavigate();

    const workNavigateHandler = () =>{
        Navigate('/contactus');
        window.scrollTo({top:0,left:0});
    }

  return (
    <div className='w-screen relative h-[300px] mt-[3rem] connect'>
        <div className='dotBG'>
            <div className=' w-auto flex flex-col justify-evenly h-[17.5rem]'>
                <div className='text-[#fff] text-[2.2rem] text-center leading-[2.5rem] connectHead'>
                    <p className='clashDisplay '>want your traits to be in the spotlight? <br/>
                        <span className='skConcretica'>You are at the right place!</span>
                    </p>
                </div>
                <button onClick={workNavigateHandler} className='text-[#fff] connectButton relative self-center text-[1.7rem] overflow-hidden skConcretica border-[1px] border-solid border-[#fff] rounded-xl px-14 py-2'>
                    <Lottie animationData={staticBg} className=' opacity-10 absolute w-[17.5rem] left-0 bottom-0' />
                    Call. Mail. Text.
                </button>
            </div>
            <div className='absolute -right-[7.5rem] -bottom-[5rem] w-[40%] connectCube'>
                <img alt='' src={cube} width='80%'/>
            </div>
        </div>
    </div>
  )
}

export default Connect